// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"54ce9f53","958":"361fd677"}[chunkId] + ".chunk.js";
};